export default __webpack_public_path__ + "static/media/feast.b78d6337.jpg";